import { render, staticRenderFns } from "./leftlogin.vue?vue&type=template&id=4915d27a&scoped=true"
import script from "./leftlogin.vue?vue&type=script&lang=js"
export * from "./leftlogin.vue?vue&type=script&lang=js"
import style0 from "./leftlogin.vue?vue&type=style&index=0&id=4915d27a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915d27a",
  null
  
)

export default component.exports